import React, { useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { registrarOnboarding } from 'services/iniciativa-action.service';
import { Step } from 'types/tutorial';
import './style.scss';

interface OnboardingModalProps {
  steps: Step[];
  onClose: () => void;
}


export const OnboardingModal: React.FC<OnboardingModalProps> = ({ steps, onClose }) => {
  const { user } = useAuth();
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = async () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      if (user?._id) {
        try {
          await registrarOnboarding(user._id);
        } catch (error) {
        }
      }

      onClose();
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const parseStepContent = (html: string) => {
    // Retorna o HTML diretamente sem modificar os estilos inline
    return html;
  };

  if (steps.length === 0) return null;

  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === steps.length - 1;

  return (
    <div className="onboarding-modal">
      <div className="onboarding-modal__card">
        <div className="onboarding-modal__image-section">
          {isFirstStep && (
            <div className="onboarding-modal__first-step-images">
            </div>
          )}
          {!isFirstStep && (
            <div className="onboarding-modal__image">
            </div>
          )}
        </div>

        <div 
          className="onboarding-modal__text"
          dangerouslySetInnerHTML={{ __html: parseStepContent(steps[currentStep].text) }}
        />

        <div className="onboarding-modal__indicators">
          {steps.map((_, index) => (
            <button
              key={index}
              className={`onboarding-modal__indicator ${index === currentStep ? 'active' : ''}`}
              onClick={() => setCurrentStep(index)}
              aria-label={`Ir para passo ${index + 1}`}
            />
          ))}
        </div>

        <div className="onboarding-modal__actions">
          {!isFirstStep && (
            <button 
              className="onboarding-modal__btn onboarding-modal__btn--secondary"
              onClick={handlePrevious}
            >
              VOLTAR
            </button>
          )}
          <button 
            className="onboarding-modal__btn onboarding-modal__btn--primary"
            onClick={handleNext}
          >
            {isFirstStep ? 'INICIAR TUTORIAL' : isLastStep ? 'FECHAR' : 'CONTINUAR'}
          </button>
        </div>
      </div>
    </div>
  );
};
